export function normalizeInteger(value, fallback, minimum = 0, maximum = Number.MAX_SAFE_INTEGER) {
	const parsed = Number.parseInt(value, 10);
	if (!Number.isFinite(parsed)) {
		return fallback;
	}

	return Math.min(maximum, Math.max(minimum, parsed));
}

export function normalizeBoolean(value) {
	return value === true || value === 1 || value === '1' || value === 'true' || value === 'yes';
}

export function createBreakpoints(settings) {
	return {
		0: {
			slidesPerView: normalizeInteger(settings.slidesMobile, 1, 1, 6),
			spaceBetween: normalizeInteger(settings.spaceMobile, 0, 0, 100),
		},
		768: {
			slidesPerView: normalizeInteger(settings.slidesTablet, 2, 1, 6),
			spaceBetween: normalizeInteger(settings.spaceTablet, 0, 0, 100),
		},
		1025: {
			slidesPerView: normalizeInteger(settings.slidesDesktop, 3, 1, 6),
			spaceBetween: normalizeInteger(settings.spaceDesktop, 0, 0, 100),
		},
	};
}

export function normalizeSettings(settings = {}, reducedMotion = false) {
	const count = normalizeInteger(settings.count, 0, 0);
	const cellAlign = ['left', 'center', 'right'].includes(settings.cellAlign) ? settings.cellAlign : 'center';

	return {
		...settings,
		count,
		cellAlign,
		breakpoints: createBreakpoints(settings),
		loop: normalizeBoolean(settings.loop) && count > 1,
		autoplay: normalizeBoolean(settings.autoplay) && !reducedMotion,
		autoplayDelay: normalizeInteger(settings.autoplayDelay, 5000, 1000, 30000),
		adaptiveHeight: normalizeBoolean(settings.adaptiveHeight),
		freeMode: normalizeBoolean(settings.freeMode),
		rtl: normalizeBoolean(settings.rtl),
		arrows: normalizeBoolean(settings.arrows),
		dots: normalizeBoolean(settings.dots),
		dragScale: normalizeBoolean(settings.dragScale) && !reducedMotion,
		scaleActive: normalizeBoolean(settings.scaleActive) && !reducedMotion,
	};
}

export function effectValues(effect, progress, reducedMotion = false) {
	const safeProgress = Number.isFinite(progress) ? progress : 0;
	const distance = Math.min(2, Math.abs(safeProgress));

	if (reducedMotion || effect === 'standard') {
		return { opacity: 1, transform: '' };
	}

	if (effect === 'fade-out') {
		return {
			opacity: Math.max(0.15, 1 - distance * 0.55),
			transform: `scale(${Math.max(0.9, 1 - distance * 0.05)})`,
		};
	}

	const shouldTransform = effect === 'circular'
		|| (effect === 'circular-start' && safeProgress < 0)
		|| (effect === 'circular-end' && safeProgress > 0);

	if (!shouldTransform) {
		return { opacity: 1, transform: '' };
	}

	const rotate = Math.max(-42, Math.min(42, safeProgress * -18));
	const translate = Math.max(-36, Math.min(36, safeProgress * 14));
	const scale = Math.max(0.84, 1 - distance * 0.08);

	return {
		opacity: Math.max(0.25, 1 - distance * 0.35),
		transform: `perspective(900px) translate3d(${translate}px, 0, 0) rotateY(${rotate}deg) scale(${scale})`,
	};
}
